module.exports = __webpack_public_path__ + "img/pic4.54419b31.png";